module.exports = __webpack_public_path__ + "static/application_for_account_opening_and_maintenance_archive-f4a0d0f74fc0ecaf1fffec1ef48a5e76.pdf";